export default class Topic {
  constructor(data = {}) {
    this.slug = data?.slug || "";
    this.comments = data?.comments || [];
    this.isLoading = data?.isLoading || false;
    this.isFetched = data?.isFetched || false;
    this.isLoading = data?.isLoading || false;
    this.postId = data.original_post_id || null;
    this.isLiked = data?.liked;
    this.canUpvote = !(data.can_like === false && data.can_undo_like === false);
    this.upvoteCount = data.like_count || 0;
    this.commentCount = data?.comments?.length || data?.total_post_count || 0;
  }

  toJson() {
    return {
      slug: this.slug,
      comments: this.comments || [],
      can_like: this.canUpvote,
      original_post_id: this.postId,
      total_post_count: this.commentCount,
      like_count: this.upvoteCount,
      liked: this.isLiked,
      isFetched: this.isFetched,
      isLoading: this.isLoading,
    };
  }

  clone() {
    return new Topic(this.toJson());
  }

  setComments(comments) {
    this.comments = comments;
    this.isFetched = true;
    return this;
  }

  setIsLoading(isLoading) {
    this.isLoading = isLoading;
    return this;
  }

  updateUpvoteData(res) {
    const {
      can_like: canLike,
      can_undo_like: canUndoLike,
      like_count: upvoteCount,
      liked,
    } = res;
    this.canUpvote = canLike || canUndoLike;
    this.isLiked = liked;
    this.upvoteCount = upvoteCount;
    return this;
  }

  toggleUpvote() {
    this.upvoteCount += this.isLiked ? -1 : 1;
    this.isLiked = !this.isLiked;
    return this;
  }
}
